import React from 'react';
import useDashboardEventSource from '../../hooks/sse-events';

export const EventInitializerDashboard = ({ SSEerror = false }) => {
  useDashboardEventSource(SSEerror);
  return <></>;
};

export default EventInitializerDashboard;
